import { Step1Schema } from "./step1";

export const RentersStep1Schema = Step1Schema;
